function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16 2H6c-3.2 0-4 .8-4 4v5.9c.03 3.03.87 3.8 4 3.8h2.25v3.55h-3.3c-.41 0-.75.34-.75.75s.34.75.75.75h7.3c-.15-.39-.22-.88-.23-1.5H9.75V15.7h2.27v-5.11c0-2.14.71-2.85 2.85-2.85h4.28c.31 0 .6.02.85.05V6c0-3.2-.8-4-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 7.79c-.25-.03-.54-.05-.85-.05h-4.28c-2.14 0-2.85.71-2.85 2.85v8.66c.01.62.08 1.11.23 1.5.35.91 1.14 1.25 2.62 1.25h4.28c2.14 0 2.85-.71 2.85-2.85v-8.56c0-1.83-.52-2.61-2-2.8zm-2.99 2.3c.87 0 1.57.7 1.57 1.57 0 .87-.7 1.57-1.57 1.57-.87 0-1.57-.7-1.57-1.57 0-.87.7-1.57 1.57-1.57zm0 9.06c-1.18 0-2.14-.96-2.14-2.14a2.142 2.142 0 013.54-1.62c.45.4.74.98.74 1.62 0 1.18-.96 2.14-2.14 2.14z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M19.15 17.01c0 1.18-.96 2.14-2.14 2.14-1.18 0-2.14-.96-2.14-2.14a2.142 2.142 0 013.54-1.62c.45.4.74.98.74 1.62zm-2.14-3.78a1.57 1.57 0 100-3.14 1.57 1.57 0 000 3.14z"
})));